export default "__VITE_ASSET__C$ocwZ_F__"